// Display names for taxonomy-mapped condition codes. Sourced from
// ~/src/longreach/cards/taxonomy.yml. Kept in sync by hand for v0.

import type { ConditionCode, ObservationType } from "./index";

export const CONDITION_NAMES: Record<ConditionCode, string> = {
  "B02.01": "Sycophancy",
  "B03.01": "Gullibility",
  "B05.01": "Amnesia",
  "B05.02": "User Repetition",
  "B05.03": "AI Repetition",
  "B05.04": "AI Regression",
  "B05.05": "User Frustration",
  "B06.01": "Confabulation",
  "B07.01": "Rationalization Bias",
  "T03.01": "Answer Thrashing",
  "T04.01": "Greed Trap",
  "R01.02": "Confirmation Bias",
  "R01.04": "Distraction",
  "M05.01": "Context Pollution",
  "H02.01": "Automation Bias",
  "H06.01": "Reverse Centaur Syndrome",
};

// Session-shape observation types are not in the taxonomy directly; they
// link to an underlying condition (Amnesia) but get their own display name.
export const TYPE_NAMES: Partial<Record<ObservationType, string>> = {
  session_user_repetition: "User Repetition",
  session_ai_regression: "AI Regression",
  session_user_frustration: "User Frustration",
};

export function displayName(o: { type: ObservationType; condition_code?: ConditionCode }): string {
  const typed = TYPE_NAMES[o.type];
  if (typed) return typed;
  if (o.condition_code) return CONDITION_NAMES[o.condition_code];
  return o.type;
}

export function displayCode(o: { type: ObservationType; condition_code?: ConditionCode }): string {
  return o.condition_code ?? o.type;
}
